import { apiCall, createQueryString } from "../imports"

const PREFIX = "clinicf/appointments"; // اصلاح شد

export default {
    get(filters) {
        return apiCall('get', `${PREFIX}${createQueryString(filters)}`);
    },
    show(id) {
        return apiCall('get', `${PREFIX}/${id}`); // اصلاح شد
    },
    create(data) {
        return apiCall('post', `${PREFIX}`, data);
    },
    update(id, data) {
        return apiCall('put', `${PREFIX}/${id}`, data);
    },
    delete(id) {
        return apiCall('delete', `${PREFIX}/${id}`);
    }
}
